<!--
 * @Author: zhangyue zhang_y1222@163.com
 * @Date: 2023-10-13 15:37:39
 * @LastEditors: zhangyue zhang_y1222@163.com
 * @LastEditTime: 2023-10-19 10:04:48
 * @FilePath: \kqcw_web\src\views\main\center.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="app-container bgF2">
    <div class="top_con">
      <img src="../../assets/img/student_head.png"
           alt="">
      <span>{{userInfo.displayName}}家长，您好！</span>
    </div>
    <div class="bottom_con">
      <div class="linkItem"
           @click="logOut">
        <span class="my-icon-exit icon_con">
          <span class="path1"></span>
          <span class="path2"></span>
          <span class="path3"></span>
          <span class="path4"></span>
        </span>
        <div class="flex_center_between border_bottom text_con">
          <span>退出登录</span>
          <van-icon name="arrow" />
        </div>
      </div>
    </div>
    <Footer page="index"
            :active="activeFooterTab"></Footer>
  </div>
</template>
  
  <script>
import { mapGetters } from 'vuex'
import { getUnbindWx } from '@/api'
import Footer from '@/components/Footer'
export default {
  components: {
    Footer,
  },
  computed: {
    ...mapGetters(['openId', 'userInfo']),
  },
  data () {
    return {
      activeFooterTab: 1,
    }
  },
  methods: {
    logOut () {
      this.$Dialog
        .confirm({
          title: '确认注销登录吗？',
          confirmButtonText: '确定',
          confirmButtonColor: '#33cd5f',
          cancelButtonText: '取消',
        })
        .then(() => {
          this.getUnbindWx()
        })
        .catch(() => { })
    },
    getUnbindWx () {
      getUnbindWx({
        openId: this.openId,
        authType: 2,
      })
        .then((res) => {
          if (res.code === 200) {

            this.$store.commit('updateBindOpenId', false)
            this.$store.commit('updateAuthType', 2)
            this.$router.push({
              path: '/',
              query: {
                authType: 2,
              },
            })
          }
        })
        .catch((err) => { })
    },
  }
}
  </script>
  
<style lang='less' scoped>
.top_con {
  height: 110px;
  // background-color: rgb(91, 166, 133);
  box-sizing: border-box;
  padding: 10px 20px;
  background-color: #fff;
  display: flex;
  align-items: center;
  font-size: 18px;

  font-weight: bold;
  img {
    width: 70px;
    // height: 90px;
    border-radius: 10px;
    margin-right: 20px;
  }
}
.bottom_con {
  height: calc(100% - 180px);
  padding: 0 10px;
  margin-top: 10px;
  background-color: #fff;
}
::v-deep .van-cell {
  padding: 10px;
}
::v-deep .van-field__label {
  width: 70px;
  margin-right: 0;
}
.linkItem {
  color: #000;
  display: flex;
  justify-content: space-between;
  .text_con {
    flex: 1;
    padding: 15px 0;
  }
  .icon_con {
    width: 32px;
    display: inline-block;
    text-align: center;
    padding: 15px 0 0;
    font-size: 22px;
    margin-right: 10px;
  }
}
</style>